import { Link } from "react-router-dom";

const UserHome = ({user}) => {

    return (
        <>
            <div className={"img-container"}>
                <img src="../img/new-logo-s.jpg" alt="" />
            </div>
            <h3 className="h3-style" style={{margin: "5% 0", color: "var(--site-light-text-color)"}}>Welcome, {user.username}</h3>
            <main className="menu-grid">
                <div className={"row"}>
                    <Link to="/diary"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Diary</p></div></Link>
                    <Link to="/events"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Results</p></div></Link>
                    <Link to="/goals"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Goals</p></div></Link>
                </div>
                <div className={"row"}>
                    <Link to="/routines"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Routines</p></div></Link>
                    <Link to="/drills"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Drills</p></div></Link>  
                    <Link to="/skills"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Skills</p></div></Link>
                </div>
                <div className={"row"}>
                    <Link to="/conditioning"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Conditioning</p></div></Link>                   
                    <Link to="/data"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Insights</p></div></Link>
                    <Link to="/resources"><div className={"menu-btn"}><p className="p-style" style={{width: '100%'}}>Resources</p></div></Link>
                </div>
            </main>
        </>
    )
  };
  
  export default UserHome;

// import { Link } from "react-router-dom";
// import { 
//   BookOpen, 
//   Trophy, 
//   Target, 
//   Repeat, 
//   Zap, 
//   Star, 
//   Dumbbell, 
//   BarChart3, 
//   BookMarked,
//   ArrowRight
// } from 'lucide-react';

// const UserHome = ({ user }) => {
//   const menuItems = [
//     { 
//       path: "/diary", 
//       title: "Diary", 
//       icon: <BookOpen className="w-6 h-6" />, 
//       color: "from-blue-500 to-blue-600",
//       hoverColor: "hover:from-blue-600 hover:to-blue-700"
//     },
//     { 
//       path: "/events", 
//       title: "Results", 
//       icon: <Trophy className="w-6 h-6" />, 
//       color: "from-amber-500 to-orange-500",
//       hoverColor: "hover:from-amber-600 hover:to-orange-600"
//     },
//     { 
//       path: "/goals", 
//       title: "Goals", 
//       icon: <Target className="w-6 h-6" />, 
//       color: "from-green-500 to-emerald-600",
//       hoverColor: "hover:from-green-600 hover:to-emerald-700"
//     },
//     { 
//       path: "/routines", 
//       title: "Routines", 
//       icon: <Repeat className="w-6 h-6" />, 
//       color: "from-purple-500 to-violet-600",
//       hoverColor: "hover:from-purple-600 hover:to-violet-700"
//     },
//     { 
//       path: "/drills", 
//       title: "Drills", 
//       icon: <Zap className="w-6 h-6" />, 
//       color: "from-indigo-500 to-blue-600",
//       hoverColor: "hover:from-indigo-600 hover:to-blue-700"
//     },
//     { 
//       path: "/skills", 
//       title: "Skills", 
//       icon: <Star className="w-6 h-6" />, 
//       color: "from-pink-500 to-rose-600",
//       hoverColor: "hover:from-pink-600 hover:to-rose-700"
//     },
//     { 
//       path: "/conditioning", 
//       title: "Conditioning", 
//       icon: <Dumbbell className="w-6 h-6" />, 
//       color: "from-red-500 to-pink-600",
//       hoverColor: "hover:from-red-600 hover:to-pink-700"
//     },
//     { 
//       path: "/data", 
//       title: "Insights", 
//       icon: <BarChart3 className="w-6 h-6" />, 
//       color: "from-cyan-500 to-teal-600",
//       hoverColor: "hover:from-cyan-600 hover:to-teal-700"
//     },
//     { 
//       path: "/resources", 
//       title: "Resources", 
//       icon: <BookMarked className="w-6 h-6" />, 
//       color: "from-slate-500 to-gray-600",
//       hoverColor: "hover:from-slate-600 hover:to-gray-700"
//     }
//   ];

//   return (
//     <div className="min-h-screen ">
//         {/* Header Section */}
//         <div className="relative overflow-hidden">
//             <div className={"img-container"}>
//                 <img src="../img/new-logo-s.jpg" alt="" />
//             </div>
//             <h3 className="h3-style" style={{margin: "5% 0", color: "var(--site-light-text-color)"}}>Welcome, {user.username}</h3>
//         </div>

//       {/* Menu Grid */}
//       <div className="px-6 pb-12">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {menuItems.map((item, index) => (
//               <Link key={item.path} to={item.path} className="group">
//                 <div className={`
//                   relative p-6 rounded-2xl shadow-lg border border-white/20 
//                   bg-gradient-to-br ${item.color} ${item.hoverColor}
//                   transform transition-all duration-300 ease-out
//                   hover:scale-105 hover:shadow-2xl hover:shadow-black/10
//                   group-hover:-translate-y-1
//                   h-35 w-40 flex flex-col
//                 `}>
                  
//                   {/* Content */}
//                   <div className="relative z-10">
//                     <div className="flex items-center justify-between mb-4">
//                       <div className="p-3 bg-white/20 rounded-xl group-hover:bg-white/30 transition-colors duration-200">
//                         <div className="text-white">
//                           {item.icon}
//                         </div>
//                       </div>
//                       <ArrowRight className="w-5 h-5 text-white/70 group-hover:text-white group-hover:translate-x-1 transition-all duration-200" />
//                     </div>
                    
//                     <div className="space-y-2">
//                       <h3 className="text-xl font-bold text-white group-hover:text-white/95 transition-colors">
//                         {item.title}
//                       </h3>
//                     </div>
//                   </div>

//                   {/* Hover glow effect */}
//                   <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-white/0 via-white/5 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default UserHome;